export enum VotingPrivacyMode {
  ANONYMOUS = 'ANONYMOUS',
  TRANSPARENT = 'TRANSPARENT',
}

export enum VotingQuestionType {
  YES_NO = 'yesno',
  SINGLE = 'single',
  MULTI = 'multi',
}

export enum VotingState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
}

export enum OptionIdEnum {
  YES = 'yes',
  NO = 'no',
}

export type OptionIdType = number | OptionIdEnum;
